export default "__VITE_ASSET__Dsuhqr$W__"